import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, HelpCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const FAQ = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  const faqs = [
    {
      question: "What happens during the free consultation?",
      answer: "We'll discuss your fitness goals, assess your current level, review any injuries or limitations, and determine the best training approach for you. No obligation required."
    },
    {
      question: "How long are training sessions?",
      answer: "Typical sessions are 60 minutes, but I offer flexible options including 45-minute and 90-minute sessions depending on your goals and schedule."
    },
    {
      question: "Do you offer online training?",
      answer: "Yes! I offer both in-person training at our facilities and online coaching programs for clients who prefer to train remotely."
    },
    {
      question: "What if I'm a complete beginner?",
      answer: "Perfect! I work with clients of all fitness levels. I'll start where you are and build a program that progresses at a pace that's comfortable for you."
    },
    {
      question: "Where do you train clients?",
      answer: "I offer personal training services in New Westminster and Burnaby, BC. We'll work at convenient locations with quality equipment."
    },
    {
      question: "What makes your training different?",
      answer: "I bring elite competition experience to everyday people. I've competed in bodybuilding and trained for marathons, so I understand what it takes. But more importantly, I specialize in creating scalable programs for busy professionals - training that fits your life, not the other way around."
    },
    {
      question: "Do you provide nutrition advice?",
      answer: "Absolutely! Nutrition is a huge part of any fitness journey. I provide personalized nutrition guidance, meal planning support, and ongoing dietary advice as part of my training programs."
    },
    {
      question: "How often should I train per week?",
      answer: "It depends on your goals, schedule, and current fitness level. Most clients train 2-4 times per week. During your consultation, we'll determine the optimal frequency for your specific situation."
    },
    {
      question: "Can you help me train for a specific event?",
      answer: "Yes! Whether it's a marathon, bodybuilding competition, or any other fitness event, I have experience preparing clients for specific goals. We'll create a periodized training plan to get you ready."
    },
    {
      question: "What if I have injuries or physical limitations?",
      answer: "I work with many clients who have injuries or limitations. We'll design your program around any restrictions, focus on proper form, and work to strengthen weak areas while avoiding aggravation of existing issues."
    },
    {
      question: "How do I get started?",
      answer: "Simply book your free consultation using the contact form or call me directly at 778-788-6448. We'll set up a time to meet, discuss your goals, and create a plan that works for you."
    },
    {
      question: "What equipment do I need for online training?",
      answer: "It depends on your goals and current setup. I can design programs that work with minimal equipment (resistance bands, dumbbells) or full gym access. We'll discuss your available equipment during the consultation."
    }
  ];

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <HelpCircle size={64} className="faq-hero-icon" data-aos="fade-up" />
          <h1 className="display-large" data-aos="fade-up" data-aos-delay="100">
            Frequently Asked Questions
          </h1>
          <p className="body-large" data-aos="fade-up" data-aos-delay="200">
            Get answers to common questions about training, programs, and getting started
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="faq-content-section">
        <div className="container">
          <div className="faq-grid-three">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="faq-box-card"
                data-aos="fade-up"
                data-aos-delay={index * 50}
              >
                <h3 className="heading-3">{faq.question}</h3>
                <p className="body-medium">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Still Have Questions CTA */}
      <section className="faq-cta-section">
        <div className="container">
          <div className="faq-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Still Have Questions?</h2>
            <p className="body-large">
              Don't see your question here? Reach out directly and I'll be happy to help.
            </p>
            <div className="faq-cta-buttons">
              <Link to="/contact">
                <Button className="btn-cta">
                  Contact Me
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </Link>
              <a href="tel:7787886448">
                <Button className="btn-secondary">
                  Call: 778-788-6448
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
